





















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import {
  User,
  Company,
  VueRoot,
  OpType,
  Branch,
  domain,
  TransactionExecute,
  CommerceCodes,
  CommerceCodesRequest
} from "@/domain";
import PayCardForm from "@/components/payment/PayCardForm.vue";
import MoneyField2 from "@/components/MoneyField2.vue";
import { PayCardInfo } from "./payment";

@Component({ components: { PayCardForm, MoneyField2 } })
export default class TxnNewDialog extends Vue {
  // New/Edit dialog
  dialog = false;
  disablePayment = true;
  savingData = false;
  branches: Branch[] = new Array<Branch>();

  companyId: null | number = null;
  branch: null | number = null;
  reference = "";
  TCOD: null | string = null;
  opType: null | OpType = null;
  newOpCentsAmount = 0;
  cardInfo: PayCardInfo = {
    cardName: "",
    cardNumber: "",
    cardExpiry: "",
    cardCvv: "",
    plateNumber: "",
    kilometers: 0
  };
  commerceCodes: CommerceCodes[] = new Array<CommerceCodes>();
  commerceCodeID: number | null = null;
  loadingCommerceCodes = false;

  get opTypes() {
    return [
      { text: this.lang.sale, value: "sale" },
      { text: this.lang.preauthorization, value: "auth" },
      { text: this.lang.amountTest, value: "test" }
    ];
  }

  get terminals() {
    if (!this.branch) return [];
    return this.branches.find((b: Branch) => b.id === this.branch)?.terminals || [];
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get langKey() {
    return this.$store.state.lang.key;
  }

  get referenceRules() {
    if (!this.reference) {
      return [];
    }
    return [util.rules.required(this.lang.ruleInsertVaule), util.rules.length(this.lang.ruleMAx500, 1, 500)];
  }

  get requiredRules() {
    return [util.rules.required(this.lang.ruleRequiredField)];
  }

  get amountRules() {
    if (!this.newOpCentsAmount) {
      return [];
    }
    return [
      util.rules.required(this.lang.ruleInsertVaule),
      (value: unknown) => util.toNumberSafe(value) > 0 || this.lang.ruleMinValue0
    ];
  }

  get originalAmountCents(): number {
    if (!this.newOpCentsAmount) {
      return 0;
    }
    return Math.abs(util.toNumberSafe(this.newOpCentsAmount)) * 100;
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  amountLabel(opType: OpType) {
    if (opType === "sale") return this.lang.collectAmount;
    if (opType === "auth") return this.lang.authAmount;
    if (opType === "test") return this.lang.testAmount;
    return this.lang.amount;
  }

  getCardInfo(value: { disablePayment: boolean; cardInfo: PayCardInfo }) {
    this.disablePayment = value.disablePayment;
    this.cardInfo = value.cardInfo;
    this.cardInfo.cardNumber = this.cardInfo.cardNumber.replaceAll(" ", "");
    this.cardInfo.cardExpiry = this.cardInfo.cardExpiry.replaceAll("/", "");
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  get disableProcessBtn() {
    if (!this.branch) return true;
    if (!this.opType) return true;
    if (!this.newOpCentsAmount) return true;
    if (!this.TCOD) return true;
    if (!this.reference) return true;
    if (this.disablePayment) return true;
    if (this.savingData) return true;
    return false;
  }

  @Watch("TCOD")
  selectTCOD() {
    this.getCommerceCodes();
  }

  async getCommerceCodes() {
    this.commerceCodes = this.getParsedCommerceCodes();
    if (this.TCOD && this.companyId) {
      this.loadingCommerceCodes = true;
      const terminal = this.terminals?.find((t) => t.tcod === this.TCOD);
      if (!terminal) {
        this.loadingCommerceCodes = false;
        return;
      }
      const request: CommerceCodesRequest = {
        companyID: this.companyId,
        branchID: util.toNumber(this.branch),
        terminalID: util.toNumber(terminal.code),
        tcod: terminal.tcod,
        language: this.langKey
      };
      const commerceCodes: CommerceCodes[] = await domain.backend.getCommerceCodes(request);
      this.commerceCodes = this.getParsedCommerceCodes(commerceCodes);
      this.loadingCommerceCodes = false;
    }
  }

  getParsedCommerceCodes(commerceCodes: CommerceCodes[] = []) {
    commerceCodes.unshift({
      code: "",
      active: true,
      id: null,
      csb: "",
      name: "Automático"
    });
    return commerceCodes;
  }

  async cmdProcess() {
    if (this.disableProcessBtn || !this.companyId || !this.TCOD || !this.opType)
      return this.snackShow(this.lang.errorCheckForm, "error");
    this.savingData = true;
    const request: TransactionExecute = {
      companyID: this.companyId,
      branchID: util.toNumber(this.branch),
      tcod: this.TCOD,
      previousTransactionID: null,
      type: this.opType,
      amountCents: this.newOpCentsAmount,
      reference: this.reference,
      comment: "",
      cardNumber: this.cardInfo.cardNumber,
      expiryDate: this.cardInfo.cardExpiry,
      commerceCodeID: this.commerceCodeID ?? undefined,
      language: this.langKey
    };

    try {
      const savedResult = await domain.backend.newTransaction(request);
      util.log("Transaction Ejecutada", savedResult);
      if (savedResult.transaction.approved === "S") {
        this.snackShow(this.lang.alertExecuteTransaction, "success");
        this.$emit("receipt", savedResult.transaction);
        this.savingData = false;
        this.close();
      } else {
        this.snackShow(savedResult.transaction.resultText || this.lang.errorCouldNotExecuteTransaction, "error");
        this.savingData = false;
      }
    } catch (error) {
      util.logError("Error ejecutar la transacción", error);
      this.savingData = false;
      this.snackShow(uiUtil.toErrorMsg(error, this.lang.errorCouldNotExecuteTransaction), "error");
    }
  }

  close() {
    this.dialog = false;
  }

  open(branches: Branch[], companyId: number) {
    this.branches = JSON.parse(JSON.stringify(branches));
    const newBranches: Branch[] = [];
    this.branches.forEach((b: Branch) => {
      if (b.id !== -1) newBranches.push(b);
    });
    this.branches = newBranches;
    this.companyId = companyId;
    this.dialog = true;
  }

  @Watch("dialog")
  clearData() {
    if (this.dialog === false) {
      // CLEAR INFORMATION
      (this.$refs.cardForm as PayCardForm).clearData();
      this.companyId = null;
      this.commerceCodeID = null;
      this.branch = null;
      this.TCOD = null;
      this.opType = null;
      this.newOpCentsAmount = 0;
      this.reference = "";
      this.cardInfo = {
        cardName: "",
        cardNumber: "",
        cardExpiry: "",
        cardCvv: "",
        plateNumber: "",
        kilometers: 0
      };
    }
  }
}
